import React from 'react';
import styled from 'styled-components';

import { MOBILE_BREAKPOINT } from 'common/hooks/useIsMobile';
import { SupportLayer } from 'modules/support';

import { Header } from '../components/layout/Header';

const StyledSupportLayer = styled(SupportLayer)`
  margin-block-start: 48px;

  @media (width >= ${MOBILE_BREAKPOINT + 1}px) {
    margin-block-start: 72px;
  }
`;

export const SupportPage = () => {
  return (
    <>
      <Header />
      <StyledSupportLayer />
    </>
  );
};
